/* eslint-disable
    react/prefer-stateless-function
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import {noop} from '@benchling/js-utils';
import $ from 'jquery';
import * as PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import getTestProps from 'test/lib/cypress/getTestProps';
import ModalButtonKey from 'test/lib/cypress/shared/ModalButtonKey';
import Modal, {ModalButton, SharedModalProps} from 'ui-library/modals/Modal';
import {InputChangeEvent} from 'util/Types';

import * as ModalContainer from '../ui-library/ModalContainer';

const ALERT_COMPONENT_MODAL_KEY = 'AlertComponentModal';
interface AlertComponentProps extends SharedModalProps {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  text: React.ReactNode;
  style: string;
}

class AlertComponent extends React.Component<AlertComponentProps> {
  static propTypes = {
    text: PropTypes.node.isRequired,
    style: PropTypes.string.isRequired,
  };

  render(): JSX.Element {
    return (
      <Modal
        enableRedesign={false}
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          buttons: [{text: 'OK', submit: true, style: this.props.style}],
        })}
      >
        {this.props.text}
      </Modal>
    );
  }
}

function alert(
  title: JSX.Element | string | null,
  text: React.ReactNode,
  type: string,
  otherProps: object = {}
): JQueryPromise<unknown> {
  if (type == null) {
    type = 'default';
  }
  const deferred = $.Deferred();
  ModalContainer.open(
    ALERT_COMPONENT_MODAL_KEY,
    <AlertComponent
      title={title}
      text={text}
      style={type}
      enableRedesign={false}
      onRequestSubmit={function (): void {
        ModalContainer.close(ALERT_COMPONENT_MODAL_KEY);
        deferred.resolve();
      }}
      onRequestClose={function (): void {
        ModalContainer.close(ALERT_COMPONENT_MODAL_KEY);
        deferred.reject();
      }}
      {...otherProps}
    />
  );
  return deferred.promise();
}

const CONFIRM_COMPONENT_MODAL_KEY = 'ConfirmComponentModal';
interface ConfirmComponentProps extends SharedModalProps {
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  text: React.ReactNode;
  style: string;
  acceptText?: string;
  acceptDisabled?: boolean;
  rejectText?: string;
  onRequestCancel?: () => void;
}

export class ConfirmComponent extends React.Component<ConfirmComponentProps> {
  static propTypes = {
    text: PropTypes.node.isRequired,
    style: PropTypes.string.isRequired,
    acceptText: PropTypes.string.isRequired,
    acceptDisabled: PropTypes.bool.isRequired,
    rejectText: PropTypes.string.isRequired,
    onRequestCancel: PropTypes.func.isRequired,
  };

  static defaultProps = {
    acceptText: 'OK',
    rejectText: 'Cancel',
    acceptDisabled: false,
    onRequestCancel: noop,
  };

  render(): JSX.Element {
    return (
      <Modal
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          buttons: [
            {text: this.props.rejectText, cancel: true, onClick: this.props.onRequestCancel},
            {
              text: this.props.acceptText,
              submit: true,
              style: this.props.style,
              disabled: this.props.acceptDisabled,
              dataTestAttrs: {
                component: 'ConfirmComponent',
                element: 'modal',
                key: ModalButtonKey.ACCEPT,
              },
            },
          ],
        })}
      >
        {this.props.text}
      </Modal>
    );
  }
}

function confirm(
  title: React.ReactNode,
  text: React.ReactNode,
  type?: string,
  {
    acceptText,
    acceptDisabled,
    rejectText,
    promiseCompatible,
    enableRedesign,
    medium,
    onSubmit,
    onCancel,
    onExit,
  }: {
    acceptText?: string;
    acceptDisabled?: boolean;
    rejectText?: string;
    promiseCompatible?: boolean;
    enableRedesign?: boolean;
    medium?: boolean;
    onSubmit?: () => void;
    onCancel?: () => void;
    onExit?: () => void;
  } = {}
): JQueryPromise<boolean> {
  if (type == null) {
    type = 'success';
  }
  const deferred: JQueryDeferred<boolean> = $.Deferred();
  ModalContainer.open(
    CONFIRM_COMPONENT_MODAL_KEY,
    <ConfirmComponent
      title={title}
      text={text}
      style={type}
      enableRedesign={enableRedesign || false}
      acceptText={acceptText}
      acceptDisabled={acceptDisabled}
      rejectText={rejectText}
      onRequestCancel={function (): void {
        if (onCancel) {
          onCancel();
        }
        ModalContainer.close(CONFIRM_COMPONENT_MODAL_KEY);
        if (promiseCompatible) {
          deferred.resolve(false);
        } else {
          deferred.reject();
        }
      }}
      medium={medium}
      onRequestSubmit={function (): void {
        if (onSubmit) {
          onSubmit();
        }
        ModalContainer.close(CONFIRM_COMPONENT_MODAL_KEY);
        if (promiseCompatible) {
          deferred.resolve(true);
        } else {
          deferred.resolve();
        }
      }}
      onRequestClose={function (): void {
        if (onExit) {
          onExit();
        }
        ModalContainer.close(CONFIRM_COMPONENT_MODAL_KEY);
        if (promiseCompatible) {
          deferred.resolve(false);
        } else {
          deferred.reject();
        }
      }}
    />
  );
  return deferred.promise();
}

const MULTI_OPTION_MODAL_KEY = 'MultiOptionModal';
interface MultiOptionButton extends ModalButton {
  value: string;
}

interface MultiOptionComponentProps extends SharedModalProps {
  buttons: Array<MultiOptionButton>;
  text: string;
  onRequestClose: (value: string) => void;
}

class MultiOptionComponent extends React.Component<MultiOptionComponentProps> {
  static propTypes = {
    // Takes a value which will either be the value of the clicked button or undefined if the 'x' is
    // clicked.
    onRequestClose: PropTypes.func.isRequired,

    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        value: PropTypes.any.isRequired,
        style: PropTypes.string,
      })
    ).isRequired,
  };

  onRequestClose = (value: string): void => {
    this.props.onRequestClose(value);
    ModalContainer.close(MULTI_OPTION_MODAL_KEY);
  };

  render(): JSX.Element {
    return (
      <Modal
        enableRedesign={false}
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          onRequestClose: this.onRequestClose,
          buttons: this.props.buttons.map((button) =>
            // eslint-disable-next-line no-restricted-syntax
            _.extend(
              {
                onClick: () => {
                  this.onRequestClose(button.value);
                },
              },
              button
            )
          ),
        })}
      >
        {this.props.text}
      </Modal>
    );
  }
}

// Returns a deferred which will be rejected if the user clicked the dialog's 'x'; otherwise will be resolved
// with the 'value' property of the clicked button.
function multiOption(
  title: JSX.Element | string | null,
  text: string,
  buttons: Array<MultiOptionButton>
): JQueryPromise<string> {
  const deferred: JQueryDeferred<string> = $.Deferred();
  ModalContainer.open(
    MULTI_OPTION_MODAL_KEY,
    <MultiOptionComponent
      title={title}
      text={text}
      buttons={buttons}
      enableRedesign={false}
      onRequestClose={function (value: string): void {
        if (value != null) {
          deferred.resolve(value);
        } else {
          deferred.reject();
        }
      }}
    />
  );
  return deferred;
}

const PROMPT_COMPONENT_MODAL_KEY = 'PromptComponentModal';
interface PromptComponentProps extends SharedModalProps {
  initialValue: string;
  onRequestSubmit: (value: string | null) => void;
  onRequestClose: () => void;
  validate: (value: string) => boolean;
  canReset?: boolean;
}
interface PromptComponentState {
  value: string;
}
class PromptComponent extends React.Component<PromptComponentProps, PromptComponentState> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static propTypes: any = {
    initialValue: PropTypes.string.isRequired,
    onRequestSubmit: PropTypes.func.isRequired,
    // Function from result string to a boolean that determined whether "OK" should be enabled.
    validate: PropTypes.func.isRequired,
    canReset: PropTypes.bool,
  };

  state: PromptComponentState = {
    value: this.props.initialValue,
  };

  inputRef = React.createRef<HTMLInputElement>();

  onRequestSubmit = (): void => {
    this.props.onRequestSubmit(this.state.value);
  };

  componentDidMount(): void {
    $(ReactDOM.findDOMNode(this.inputRef.current)!).focus().select();
  }

  handleChange = (event: InputChangeEvent): void => {
    this.setState({value: event.target.value});
  };

  render(): JSX.Element {
    return (
      <Modal
        enableRedesign={false}
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          onRequestSubmit: this.onRequestSubmit,
          buttons: _.compact([
            {
              text: 'OK',
              submit: true,
              style: 'success',
              disabled: !this.props.validate(this.state.value),
              dataTestAttrs: {
                component: 'PromptComponent',
                element: 'modal',
                key: 'okButton',
              },
            },
            {text: 'Cancel', cancel: true},
            this.props.canReset
              ? {
                  text: 'Reset',
                  onClick: () => {
                    this.props.onRequestSubmit(null);
                  },
                  style: 'danger',
                  pullLeft: true,
                }
              : undefined,
          ]),
        })}
        dataTestAttrs={{component: 'PromptComponent', element: 'modal'}}
      >
        <input
          type="text"
          value={this.state.value}
          onChange={this.handleChange}
          ref={this.inputRef}
          {...getTestProps({component: 'PromptComponent', element: 'input'})}
        />
      </Modal>
    );
  }
}

function prompt(
  title: JSX.Element | string | null,
  initialValue?: string | null,
  validate?: (value: string) => boolean,
  param?: {canReset?: boolean}
): JQueryPromise<string> {
  if (initialValue == null) {
    initialValue = '';
  }
  if (validate == null) {
    validate = () => true;
  }
  if (param == null) {
    param = {};
  }
  const {canReset} = param;
  const deferred: JQueryDeferred<string> = $.Deferred();
  ModalContainer.open(
    PROMPT_COMPONENT_MODAL_KEY,
    <PromptComponent
      title={title}
      initialValue={initialValue}
      validate={validate}
      canReset={canReset}
      enableRedesign={false}
      onRequestSubmit={function (value: string): void {
        ModalContainer.close(PROMPT_COMPONENT_MODAL_KEY);
        deferred.resolve(value);
      }}
      onRequestClose={function (): void {
        ModalContainer.close(PROMPT_COMPONENT_MODAL_KEY);
        deferred.reject();
      }}
    />
  );
  return deferred.promise();
}

export {alert, confirm, prompt, multiOption, PromptComponent as PromptModal};
